import * as React from 'react';
import { st, classes } from './TabsNavButton.st.css';
import { isSelectKey } from '../../../common/keyCodes';
import { TabsNavButtonProps } from './types';

export class TabsNavButton extends React.Component<TabsNavButtonProps> {
  private _rootRef: HTMLDivElement;

  width() {
    return this._rootRef ? this._rootRef.offsetWidth : 0;
  }

  _onKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    const { onClick } = this.props;

    if (isSelectKey(e)) {
      onClick();
      return false;
    }

    return undefined;
  };

  _rootRefCallback = (el: HTMLDivElement) => {
    this._rootRef = el;
  };

  render() {
    const { onClick, children, className } = this.props;

    return (
      <div
        className={st(classes.root, className)}
        onClick={onClick}
        onKeyDown={this._onKeyDown}
        tabIndex={-1}
        data-hook={this.props['data-hook']}
        aria-hidden={true}
        ref={this._rootRefCallback}
      >
        {children}
        <div className={classes.border} />
      </div>
    );
  }
}
